export interface IUnitPropertyAPI {
  unitproperty_id: number;
  unit_id?: number;
  key: string;
  value: string;
  is_required: boolean;
  name: string;
}

export default class UnitProperty {
  unitproperty_id: number;

  unit_id: number;

  key: string;

  value: string;

  isRequired: boolean;

  name: string;

  constructor(id = -1, unitId: number, key: string, value: string, isRequired: boolean, name: string) {
    this.unitproperty_id = id;
    this.unit_id = unitId;
    this.key = key;
    this.value = value;
    this.isRequired = isRequired;
    this.name = name;
  }

  static fromApi(apiObject: IUnitPropertyAPI): UnitProperty {
    return new UnitProperty(
      apiObject.unitproperty_id,
      apiObject.unit_id,
      apiObject.key,
      apiObject.value,
      apiObject.is_required,
      apiObject.name,
    );
  }

  toApi(): IUnitPropertyAPI {
    const toReturn: IUnitPropertyAPI = {
      unitproperty_id: this.unitproperty_id >= 0 ? this.unitproperty_id : undefined,
      key: this.key,
      value: this.value,
      is_required: this.isRequired,
      name: this.name,
    };
    if (this.unit_id !== null && this.unit_id !== undefined) {
      toReturn.unit_id = this.unit_id;
    }
    return toReturn;
  }

  toString() {
    return (this.name || this.key) + ': ' + this.value;
  }

  static validatorCreateRules(): Record<string, string> {
    return {
      unit_id: 'required|numeric|int',
      key: 'required|not_empty',
      name: 'required|not_empty',
      value: 'required|not_empty',
    };
  }

  static validatorUpdateRules(): Record<string, string> {
    return {
      unitproperty_id: 'required|numeric|int',
      unit_id: 'required|numeric|int',
      key: 'required|not_empty',
      name: 'required|not_empty',
      value: 'required|not_empty',
    };
  }
}
